export default function dayDefaultHighlight(Utils) {
  'ngInject';

  return {
    require: ['^?datepickerDefaultDayHighlight', '^ngModel'],
    link($scope, $element, $attrs, [datepickerDefaultDayHighlight, ngModel]) {
      if (
        datepickerDefaultDayHighlight &&
        !ngModel.$viewValue &&
        Utils.formatDate(datepickerDefaultDayHighlight.defaultDate) ===
          Utils.formatDate($scope.dt.date)
      ) {
        $element.addClass('day-default-highlight');
      }
    },
  };
}
